/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ processed: NonNullable<unknown>, total: NonNullable<unknown> }} Ui_Import_ProgressInputs */

const en_ui_import_progress = /** @type {(inputs: Ui_Import_ProgressInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.processed} / ${i?.total}`)
};

const de_ui_import_progress = /** @type {(inputs: Ui_Import_ProgressInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.processed} / ${i?.total}`)
};

/**
* | output |
* | --- |
* | "{processed} / {total}" |
*
* @param {Ui_Import_ProgressInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_import_progress = /** @type {((inputs: Ui_Import_ProgressInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Import_ProgressInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_import_progress(inputs)
	return de_ui_import_progress(inputs)
});